import { StyleRulesCallback } from "@material-ui/core/styles";
import { createCallToAction } from "./CallToAction";

const styles: StyleRulesCallback = ({ spacing }) => ({
  root: {
    marginTop: spacing.unit * 3
  }
});

export const CustomMainCta = createCallToAction(styles);
